var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    viewBox: "0 0 1050 1049.999947",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1b379ffc8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.140625 33.078125 L 1035.058594 33.078125 L 1035.058594 1049.996094 L 18.140625 1049.996094 Z M 18.140625 33.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed100f7276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1035.058594 541.539062 C 1035.058594 822.351562 807.410156 1049.996094 526.597656 1049.996094 C 245.785156 1049.996094 18.140625 822.351562 18.140625 541.539062 C 18.140625 260.726562 245.785156 33.078125 526.597656 33.078125 C 807.410156 33.078125 1035.058594 260.726562 1035.058594 541.539062 Z M 1035.058594 541.539062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2d6359d44a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1035.058594 541.539062 C 1035.058594 822.351562 807.410156 1049.996094 526.597656 1049.996094 C 245.785156 1049.996094 18.140625 822.351562 18.140625 541.539062 C 18.140625 260.726562 245.785156 33.078125 526.597656 33.078125 C 807.410156 33.078125 1035.058594 260.726562 1035.058594 541.539062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2a7950e244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 704.886719 -443.101562 L -458.039062 363.25 L 348.3125 1526.175781 L 1511.238281 719.824219 Z M 704.886719 -443.101562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.00730858,
    gradientTransform: "matrix(827.001908, 1192.696109, -1192.696109, 827.001908, 129.468465, -31.206558)",
    y1: 0,
    x2: 0.967726,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "35b36f19a3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.89856%, 10.998535%, 14.099121%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.89856%, 10.998535%, 14.099121%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.629456%, 9.901428%, 12.678528%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.360352%, 8.805847%, 11.257935%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.24231%, 7.333374%, 9.5047%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.124268%, 5.862427%, 7.752991%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.855164%, 4.690552%, 6.239319%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.587585%, 3.518677%, 4.725647%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.36731%, 2.397156%, 3.208923%)",
    offset: 0.0351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.14856%, 1.275635%, 1.693726%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.551392%, 0.65918%, 0.889587%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.95575%, 0.0427246%, 0.0869751%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.787903%, 0.0213623%, 0.231934%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.516296%, 0.0930786%, 0.389099%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.308777%, 0.289917%, 0.39978%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.105835%, 0.491333%, 0.494385%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.910522%, 0.688171%, 0.688171%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.709106%, 0.791931%, 0.888062%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.501587%, 0.799561%, 1.095581%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.202515%, 0.996399%, 1.199341%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.81189%, 1.387024%, 1.390076%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.535706%, 1.589966%, 1.686096%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.37854%, 1.599121%, 1.893616%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.105408%, 1.792908%, 2.192688%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.714783%, 1.992798%, 2.392578%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.41571%, 2.09198%, 2.468872%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.208191%, 2.290344%, 2.616882%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.909119%, 2.540588%, 2.890015%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.610046%, 2.693176%, 3.091431%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.402527%, 2.69928%, 3.09906%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.298767%, 2.896118%, 3.295898%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.106506%, 3.094482%, 3.686523%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.812012%, 3.193665%, 3.889465%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.604492%, 3.393555%, 3.898621%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.30542%, 3.692627%, 4.092407%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.914795%, 3.892517%, 4.483032%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.615723%, 3.991699%, 4.782104%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.408203%, 4.190063%, 4.989624%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.206787%, 4.391479%, 5.096436%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.011475%, 4.588318%, 5.099487%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.810059%, 4.692078%, 5.195618%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.601013%, 4.699707%, 5.397034%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.350769%, 4.896545%, 5.696106%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.010498%, 5.09491%, 5.89447%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.712952%, 5.194092%, 5.993652%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.503906%, 5.393982%, 6.193542%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.204834%, 5.693054%, 6.492615%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.814209%, 5.892944%, 6.88324%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.515137%, 5.992126%, 7.089233%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.307617%, 6.190491%, 7.099915%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.008545%, 6.295776%, 7.292175%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.709473%, 6.394958%, 7.565308%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.500427%, 6.596375%, 7.720947%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.201355%, 6.896973%, 7.798767%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.81073%, 7.095337%, 7.989502%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.511658%, 7.194519%, 8.285522%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.304138%, 7.392883%, 8.493042%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.005066%, 7.644653%, 8.79364%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.661743%, 7.794189%, 8.99353%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.413025%, 7.891846%, 9.092712%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.207031%, 8.09021%, 9.289551%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.907959%, 8.195496%, 9.590149%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.608887%, 8.294678%, 9.791565%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.401367%, 8.496094%, 9.799194%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.102295%, 8.796692%, 9.996033%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.71167%, 8.995056%, 10.386658%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.412598%, 9.094238%, 10.68573%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.203552%, 9.294128%, 10.89325%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.90448%, 9.397888%, 10.998535%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.513855%, 9.588623%, 11.18927%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.214783%, 9.883118%, 11.482239%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.007263%, 10.090637%, 11.689758%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.708191%, 10.195923%, 11.79657%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.409119%, 10.295105%, 11.895752%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.201599%, 10.496521%, 12.097168%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.902527%, 10.797119%, 12.347412%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.559204%, 10.995483%, 12.496948%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.30896%, 11.09314%, 12.594604%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.104492%, 11.29303%, 12.792969%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.80542%, 11.398315%, 13.093567%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.414795%, 11.58905%, 13.484192%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.115723%, 11.883545%, 13.68866%)",
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.906677%, 12.091064%, 13.699341%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.607605%, 12.19635%, 13.891602%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.308533%, 12.271118%, 14.189148%)",
    offset: 0.851563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.101013%, 12.42218%, 14.395142%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.801941%, 12.5%, 14.498901%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.411316%, 12.690735%, 14.691162%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.112244%, 12.986755%, 14.985657%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.903198%, 13.194275%, 15.193176%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.604126%, 13.298035%, 15.493774%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.213501%, 13.48877%, 15.693665%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.914429%, 13.783264%, 15.792847%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.706909%, 13.990784%, 15.989685%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.600098%, 14.096069%, 16.290283%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.52533%, 14.195251%, 16.491699%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.374268%, 14.395142%, 16.499329%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.101135%, 14.498901%, 16.696167%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1b379ffc8e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed100f7276)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2d6359d44a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a7950e244)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#35b36f19a3)",
    d: "M 704.882812 -443.097656 L -458.039062 363.257812 L 348.316406 1526.175781 L 1511.238281 719.820312 Z M 704.882812 -443.097656 ",
    fillRule: "nonzero"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#efeadd",
    d: "M 780.003906 498.550781 L 431.144531 297.136719 C 397.234375 277.5625 354.84375 302.03125 354.84375 341.191406 L 354.84375 744.007812 C 354.84375 783.167969 397.234375 807.636719 431.144531 788.0625 L 780.003906 586.648438 C 813.910156 567.074219 813.910156 518.125 780.003906 498.550781 L 431.144531 297.136719 C 397.234375 277.5625 354.84375 302.03125 354.84375 341.191406 L 354.84375 744.007812 C 354.84375 783.167969 397.234375 807.636719 431.144531 788.0625 L 780.003906 586.648438 C 813.910156 567.074219 813.910156 518.125 780.003906 498.550781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a648770a41f582225a792d78b7c01100.svg";
export { ForwardRef as ReactComponent };